import api from '../services/api';
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';

export default function Dashboard() {
  const container = document.createElement('div');
  container.className = 'content';

  // Cabeçalho
  const header = document.createElement('div');
  header.className = 'card';
  header.innerHTML = `<h2>Dashboard</h2>`;
  container.appendChild(header);

  // Cards principais
  const cards = document.createElement('div');
  cards.className = 'card-grid';
  container.appendChild(cards);

  // Card do gráfico
  const chartCard = document.createElement('div');
  chartCard.className = 'card';
  chartCard.innerHTML = `
    <h3>Mobi Light - 6 meses</h3>
    <canvas id="chartTerapias"></canvas>
  `;
  container.appendChild(chartCard);

  async function carregarDados() {
    try {
      const res = await api.get('/dashboard');
      const data = res.data || {};

      const {
        totalPacientes = 0,
        novosPacientes = 0,
        totalTerapias = 0,
        terapiasMes = 0,
        evolucaoTerapias = 0,
        totalMobiLight = 0,
        terapiasMobiLight = 0,
        terapiasPorMes = []
      } = data;

      // Cards
      cards.innerHTML = `
        <div class="card small">
          <h4><i class="fa-solid fa-user-group"></i> Pacientes</h4>
          <p>Total de pacientes: <b>${totalPacientes}</b></p>
          <p>Novos no mês: ${novosPacientes}</p>
        </div>
        <div class="card small">
          <h4><i class="fa-solid fa-heart-pulse"></i> Terapias</h4>
          <p>Total de terapias: <b>${totalTerapias}</b></p>
          <div class="indicadores">
            <p class="inline">
              Novas no mês: <b>${terapiasMes}</b>
            </p>
            <p class="inline evolucao">
              Evolução: 
              <span style="color:${evolucaoTerapias >= 0 ? '#4da3ff' : '#ff4d4d'};">
                ${evolucaoTerapias > 0 ? '+' : ''}${evolucaoTerapias}%
              </span>
            </p>
          </div>
        </div>
        <div class="card small">
          <h4><i class="fa-solid fa-microchip"></i> Mobi Light</h4>
          <p>Total equipamentos: <b>${totalMobiLight}</b></p>
          <p>Terapias realizadas: ${terapiasMobiLight}</p>
        </div>
      `;
/*
function gerarCor(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = 240; // azul
  const saturation = 80 + (hash % 20); // entre 80% e 100%
  const lightness = 30 + (hash % 20);  // entre 30% e 50%
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}*/

function gerarCor(index) {
  return palette[index % palette.length];
}

const palette = [
  '#e63946', // vermelho forte
  '#457b9d', // azul
  '#2a9d8f', // verde
  '#f4a261', // laranja
  '#8d99ae', // cinza
  '#6a4c93'  // roxo
];




      // Gráfico terapias/mês
      const ctx = chartCard.querySelector('#chartTerapias');
      if (terapiasPorMes.length > 0) {

         const labels = data.meses; // 🔹 pega direto do backend


          const datasets = terapiasPorMes.map(mobi => ({
            label: mobi.numero_serie,
            data: mobi.meses,
            backgroundColor: gerarCor(mobi.numero_serie),
            borderRadius: 6
          }));
        
        
        Chart.register(ChartDataLabels);

        new Chart(ctx, {
            type: 'bar',
            data: {
              labels,
              datasets
            },
   options: {
      layout: {
        padding: { top: 20, bottom: 20 }
      },
      elements: {
  bar: {
    borderWidth: 1,
    hoverBorderWidth: 2,
    borderSkipped: false, // garante que o hitbox cubra toda a barra
  }
},
      responsive: true,
      maintainAspectRatio: false,
      interaction: {
        mode: 'nearest',   // só mostra o tooltip da barra mais próxima
        intersect: true    // exige que o mouse esteja sobre a barra
      },
      scales: {
        y: {
          beginAtZero: true,
          ticks: {
            stepSize: 1,
            callback: value => Number.isInteger(value) ? value : null
          }
        }
      },
      plugins: {
        tooltip: {
          enabled: true,
          callbacks: {
            label: context => {
              const label = context.dataset.label || '';
              const value = context.parsed.y;
              return `Mobi Light ${label}: ${value}`;
            }
          }
        },
        legend: { position: 'top' },
        datalabels: {
          anchor: 'end',
          align: 'start',
          color: '#000',
          font: { weight: 'bold' },
          formatter: value => value
        }
      }
    }

          });
        //chartCard.style.height = '400px'; 
      } else {
        chartCard.innerHTML += `<p style="color:#aaa;">Sem dados de terapias por mês.</p>`;
      }
    } catch (err) {
      console.error('Erro ao carregar dashboard:', err);
      cards.innerHTML = `<p style="color:red;">Erro ao carregar dados do dashboard.</p>`;
    }
  }

  carregarDados();
  return container;
}
